import { useStore } from 'effector-react';
import { SceneType } from '@types';
import { $loadedScene } from '@stores/loadedStore';
import { PlayerContainer } from './PlayerContainer';

export function CompareLayer() {
  const loadedScene = useStore($loadedScene);
  if (!loadedScene) return null;
  if (loadedScene.type !== SceneType.pano) return null;
  return <PlayerContainer loadedScene={loadedScene} />;
}
